module.exports = __webpack_public_path__ + "img/ravenscroft.09a8bda1.png";